import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'gg-download-icon',
  templateUrl: './download-icon.component.html',
  styleUrls: ['./download-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DownloadIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
